import {
    SiCss3,
    SiFirebase,
    SiGit,
    SiGithub,
    SiGithubactions,
    SiHtml5,
    SiJavascript,
    SiMongodb,
    SiNetlify,
    SiNodedotjs,
    SiPython,
    SiReact,
    SiRedux,
    SiSass,
    SiTailwindcss,
} from "react-icons/si";


export const Icons = {
    SiJavascript,
    SiCss3,
    SiHtml5,
    SiMongodb,
    SiNodedotjs,
    SiPython,
    SiReact,
    SiSass,
    SiGit,
    SiGithub,
    SiGithubactions,
    SiRedux,
    SiNetlify,
    SiFirebase,
    SiTailwindcss,
};